import '../../style/base.css';
import '../../info/index.css';
import '../../sticky/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/tabs/style/index.js
// module id = 186
// module chunks = 31